import "./App.css";
import Hero from "./components/Hero";
import Section from "./components/Section";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Hero />
      <Section id="gigs" />
      <Footer />
    </div>
  );
}

export default App;
